import React,{ useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import * as yup from "yup";
import FormSelect from '../../Generic/FormSelect';

const Edit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { mainStore } = useStore();
    const axiosPrivate = useAxiosPrivate();
    const { t } = useTranslation();
    useSetMenu(mainStore.CategoryMenuType, mainStore.CategoryMenuNo);
    const schema = yup.object({
        name: yup
            .string()
            .required(t('requiredField'))
            .max(250, t('maxLength', { max: 250 })),
        panelId: yup.string().required(t("selectRequired")),
    });

    const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
    const onSubmit = data => updateData(data);

    const [panels, setPanels] = useState([]);
    const [selectedPanel, setSelectedPanel] = useState(null);
    const additionalDataFetch = async (categoryData) => {
        try {
            const panelsResponse = await axiosPrivate.get("/Panels/SelectOptions");
            setPanels(panelsResponse.data);
            const selected = panelsResponse.data.find(c => c.value === categoryData.panelId.toString());
            setSelectedPanel(selected);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handlePanelChange = selectedOption => {
        setSelectedPanel(selectedOption);

        setValue("panelId", selectedOption.value, { shouldValidate: true });
    };

    const { notFound, updateData } = useEditData(axiosPrivate, "/Categories", id, setValue, navigate,additionalDataFetch);

    const goToList = () => {
        navigate("/Category/List");
    };

    if (notFound) {
        return <div className="not-found-myDiv">
            <div className="not-found-container">
                <div className="not-found-content">
                    <h1>{t("pageNotFoundTitle")}</h1>
                    <p>{t("noDataWithIdMessage")}</p>
                    <button onClick={goToList} className="btn btn-primary">
                        {t("goTo") + " " + t("list") + " " + t("categories")}
                    </button>
                </div>
            </div>
        </div>;
    }

    return (
        <FormLayout title={t("categoryEditTitle")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
            <FormSelect label="panel" name="panelId" options={panels} value={selectedPanel} onChange={handlePanelChange} register={register} errors={errors} />
            <FormInput label="category" name="name"  register={register} errors={errors} />
            <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
        </FormLayout>
    );
};

export default observer(Edit);